import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-search-bar',
    imports: [
        MatIconModule,
        FormsModule,
        CommonModule
    ],
    standalone: true,
    templateUrl: './searchBar.component.html',
    styleUrl: './searchBar.component.scss'
})

export class SearchBarComponent {
  @Input() value: string = '';
  @Input() width: number = 200;
  @Output() searchText: EventEmitter<string> = new EventEmitter<string>();
  @Output() inputBlur: EventEmitter<void> = new EventEmitter<void>();
  @Output() enterPressed: EventEmitter<void> = new EventEmitter<void>();

  isSearchOpen: boolean = false;

  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;
  }

  onSearch() {
    if (this.value) {
      this.searchText.emit(this.value);
    }
  }

  clearSearch() {
    this.value = '';
    this.searchText.emit(this.value);
  }

  applyFilter(event: KeyboardEvent) {
    this.searchText.emit(this.value);

    if (event.key === 'Enter') {
      this.enterPressed.emit();
    }
  }

  handleBlur() {
    this.value = "";
    this.inputBlur.emit();
  }
}

